import React from "react";

import { useSelector } from "react-redux";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";

import { templatesList } from "../../../constants";
import AdminContractsCards from "./AdminContractsCards";
import AdminContractsList from "./AdminContractsList";

function AdminContracts() {
	const { masterContracts } = useSelector((state) => state.admin);

	return (
		<Box
			sx={{
				display: "flex",
				flexBasis: "75%",
				flexWrap: "wrap",
				rowGap: "1rem",
			}}
		>
			<Paper
				sx={{
					flexBasis: "100%",
					display: "flex",
					flexWrap: "nowrap",
					alignItems: "center",
					justifyContent: "center",
					columnGap: "1rem",
				}}
			>
				{templatesList.length > 0 ? (
					<AdminContractsCards templates={templatesList} />
				) : (
					<div className="d-flex justify-content-center mt-2">
						<p>No Results</p>
					</div>
				)}
			</Paper>
			<Paper sx={{ flexBasis: "100%" }}>
				{masterContracts.length > 0 ? (
					<AdminContractsList />
				) : (
					<Box sx={{ m: "2rem 0", textAlign: "center" }}>
						Not items available
					</Box>
				)}
			</Paper>
		</Box>
	);
}

export default AdminContracts;
